import React from "react";
import { useIntl } from "react-intl";

import * as Utils from "../../../Utils/StringUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faComments, faCamera, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const ThresholdsCard = (props) => {
    const intl = useIntl();

    const border_color = props.exceeded ? "border-warning" : "border-success";

    const getIconGroup = (groupName) => {
        switch (groupName) {
            case "administration": return faCogs;
            case "storage": return faFolderOpen
            case "resources": return faComments
            case "webrtc_minutes": return faCamera
            default: return faCogs
        }
    }

    const monthOfYear = Utils.capitalizeFirstLetter(intl.formatDate(Date.now(), {month: "long"}));

    return (
        <div className={"card "+ border_color}>
            <div className="card-body text-center">
                <FontAwesomeIcon icon={getIconGroup(props.groupName)} size="3x" className="mt-2" color="#adb5bd" />
                <h4 className="text-uppercase mt-3">{props.groupName}</h4>
                <h1 className="mt-2">{props.value}</h1>
                <p className="text-uppercase" style={{letterSpacing:".2rem"}}>{props.unit}</p>
            </div>
            <div className="footer text-center"><p>{monthOfYear}</p></div>
        </div>
    )
}

export default (ThresholdsCard);